/**
 * Nombres canonicos de los eventos de analytics del dominio de suscripcion.
 * Cada valor sigue el formato `front.<dominio>.<entidad>.<accion>` y se consume
 * unicamente a traves de `useSubscriptionAnalytics`, nunca importando el SDK
 * de PostHog directamente.
 *
 * `PURCHASE_CTA` conserva su nombre legacy `front.global.*` porque ya emite en
 * produccion con dashboards que dependen de el; renombrarlo partiria el
 * historico.
 */
export const SUBSCRIPTION_EVENTS = {
  PURCHASE_CTA: 'front.global.click.purchase_cta',
  PAYMENT_METHOD_ADD: 'front.subscription.button.paymentMethod.add',
  PAY_PLAN: 'front.subscription.button.pay_plan',
  // U4/U6 — el embudo de la compra de asiento dentro del alta de usuario: que se
  // mostro, que se envio, como termino y quien se fue sin comprar.
  SEAT_DISCLOSURE_SHOWN: 'front.subscription.seat.disclosure_shown',
  SEAT_PURCHASE_SUBMIT: 'front.subscription.seat.purchase_submit',
  SEAT_PURCHASE_OUTCOME: 'front.subscription.seat.purchase_outcome',
  SEAT_FLOW_ABANDONED: 'front.subscription.seat.flow_abandoned',
} as const;
